import HeaderLinks from "../HeaderLinks/HeaderLinks";

const HeaderSecondary = () => {
    return ( 
        <div>
            <HeaderLinks/>
        </div>
    );
}
export default HeaderSecondary;